export const airPriceWatchOptInQuery = `
    query airPriceWatchOptInResponse($input: AirPriceWatchOptInRequest) {
        airPriceWatchOptInResponse(input: $input) {
            status
            statusCode
            statusMessage
            watchId
            prefManagementResp
            priceWatchOptInReq
        }
    }
`
